import {
  FeaturedPackagingAttribute,
  FeaturedPackagingAttributeKey,
  FeaturedPackagingCard,
  FeaturedPackagingCategory,
  PackagingCard,
  PackagingKind,
  PlacementOption,
} from 'src/shared/types/featured-packaging';
import { STATIC_FILE_URL } from '@/shared/constants';

export const PACKAGING_PROMO_CODE = 'PACKAGING10';

// TODO: update to a cleaner solution
// FPDM = Featured Packaging Discount Multiple. This is a multiple that quickly gets rid of the logistics fee
export const FPDM = 0.85;

export const CUSTOM_PACKAGING_CONFIG: { [key: string]: FeaturedPackagingCard } = {
  [FeaturedPackagingCategory.POLYMAILERS]: {
    kind: PackagingKind.FEATURED,
    key: FeaturedPackagingCategory.POLYMAILERS,
    categoryId: 3204,
    image: `${STATIC_FILE_URL}/dfd0e978403eafeaf254672d8c22e0e4.png`,
    title: 'Polymailers',
    options: {
      default: {
        label: 'default',
        sizes: [
          {
            height: 7.5,
            width: 10.5,
            description: 'For single t-shirt',
            pricing: {
              '50': FPDM * 1.68,
              '100': FPDM * 1.19,
              '200': FPDM * 0.91,
              '500': FPDM * 0.68,
              '1000': FPDM * 0.57,
              '2500': FPDM * 0.47,
              '5000': FPDM * 0.4,
            },
          },
          {
            height: 10,
            width: 13,
            description: 'For long sleeve shirt',
            pricing: {
              '50': FPDM * 2.1,
              '100': FPDM * 1.58,
              '200': FPDM * 1.25,
              '500': FPDM * 0.97,
              '1000': FPDM * 0.83,
              '2500': FPDM * 0.68,
              '5000': FPDM * 0.59,
            },
          },
          {
            height: 14.5,
            width: 19,
            description: 'For a sweatshirt',
            pricing: {
              '50': FPDM * 3.2,
              '100': FPDM * 2.55,
              '200': FPDM * 2.11,
              '500': FPDM * 1.7,
              '1000': FPDM * 1.47,
              '2500': FPDM * 1.22,
              '5000': FPDM * 1.07,
            },
          },
        ],
      },
    },
    cardColor: '#E7D4CF',
    textColor: '#804434',
    invoiceTitle: 'USA Made Polymailer',
    description:
      'Select a size, quantity and upload a custom image directly to create a USA Made polymailer for your needs.',
    exampleImages: [
      `${STATIC_FILE_URL}/3261e46501931b9a07320ce4ab57d030.png`,
      `${STATIC_FILE_URL}/e56d8efde0b0ad7b154e6c518bbdc957.png`,
      `${STATIC_FILE_URL}/85ba98f7fdf2bacc920dae38e790ba4e.png`,
      `${STATIC_FILE_URL}/63f98b1b7f3adc05c24fa11cd5074821.png`,
    ],
    startingPointTitle: 'USA Made Polymailers',
  },
  [FeaturedPackagingCategory.NOTECARDS]: {
    kind: PackagingKind.FEATURED,
    key: FeaturedPackagingCategory.NOTECARDS,
    categoryId: 3212,
    image: `${STATIC_FILE_URL}/9542f6c9330c552c5fac7323d90e9909.png`,
    title: 'Notecards',
    options: {
      default: {
        label: 'default',
        sizes: [
          {
            height: 3.5,
            width: 5,
            pricing: {
              '25': FPDM * 0.56,
              '50': FPDM * 0.36,
              '75': FPDM * 0.3,
              '100': FPDM * 0.26,
              '125': FPDM * 0.25,
              '150': FPDM * 0.23,
              '175': FPDM * 0.22,
              '200': FPDM * 0.22,
              '250': FPDM * 0.21,
              '500': FPDM * 0.19,
              '1000': FPDM * 0.18,
              '2000': FPDM * 0.18,
            },
          },
          {
            height: 4.25,
            width: 5.5,
            pricing: {
              '25': FPDM * 0.59,
              '50': FPDM * 0.39,
              '75': FPDM * 0.32,
              '100': FPDM * 0.29,
              '125': FPDM * 0.27,
              '150': FPDM * 0.25,
              '175': FPDM * 0.24,
              '200': FPDM * 0.24,
              '250': FPDM * 0.23,
              '500': FPDM * 0.21,
              '1000': FPDM * 0.2,
              '2000': FPDM * 0.2,
            },
          },
          {
            height: 4,
            width: 6,
            pricing: {
              '25': FPDM * 0.8,
              '50': FPDM * 0.59,
              '75': FPDM * 0.52,
              '100': FPDM * 0.48,
              '125': FPDM * 0.46,
              '150': FPDM * 0.45,
              '175': FPDM * 0.44,
              '200': FPDM * 0.43,
              '250': FPDM * 0.42,
              '500': FPDM * 0.4,
              '1000': FPDM * 0.39,
              '2000': FPDM * 0.38,
            },
          },
          {
            height: 5,
            width: 7,
            pricing: {
              '25': FPDM * 0.8,
              '50': FPDM * 0.59,
              '75': FPDM * 0.52,
              '100': FPDM * 0.48,
              '125': FPDM * 0.46,
              '150': FPDM * 0.45,
              '175': FPDM * 0.44,
              '200': FPDM * 0.43,
              '250': FPDM * 0.42,
              '500': FPDM * 0.4,
              '1000': FPDM * 0.39,
              '2000': FPDM * 0.38,
            },
          },
        ],
      },
    },
    cardColor: '#E7CEDF',
    textColor: '#442239',
    invoiceTitle: 'Custom Notecard',
    description:
      'Select a size, quantity and upload a custom image directly to create a custom notecard for your needs.',
    exampleImages: [
      `${STATIC_FILE_URL}/598d40b48e84819ce0f582ed62815984.png`,
      `${STATIC_FILE_URL}/fe314b51cfa519a7189a2125822de5ad.png`,
      `${STATIC_FILE_URL}/e7a865dfacf6332baa5160a44892c550.png`,
      `${STATIC_FILE_URL}/4a14e14ccf54063fa11b3aa2a1657e06.png`,
    ],
    startingPointTitle: 'Custom Notecards',
  },
  [FeaturedPackagingCategory.STICKERS]: {
    kind: PackagingKind.FEATURED,
    key: FeaturedPackagingCategory.STICKERS,
    categoryId: 3210,
    image: `${STATIC_FILE_URL}/8889bc70fc8eb4a24c013d821adcf80f.png`,
    title: 'Stickers',
    options: {
      'Die cut': {
        label: 'Die cut stickers',
        description:
          'Custom die cut stickers are a fast and easy way to promote your business, brand or event. Thick, durable vinyl protects your stickers from scratches, water & sunlight.',
        sizes: [
          {
            height: 2,
            width: 2,
            pricing: {
              '50': FPDM * 1.16,
              '100': FPDM * 0.69,
              '200': FPDM * 0.44,
              '300': FPDM * 0.35,
              '500': FPDM * 0.27,
              '1000': FPDM * 0.2,
              '2000': FPDM * 0.16,
              '3000': FPDM * 0.14,
              '5000': FPDM * 0.13,
              '10000': FPDM * 0.11,
            },
          },
          {
            height: 3,
            width: 3,
            pricing: {
              '50': FPDM * 1.36,
              '100': FPDM * 0.86,
              '200': FPDM * 0.59,
              '300': FPDM * 0.49,
              '500': FPDM * 0.4,
              '1000': FPDM * 0.31,
              '2000': FPDM * 0.26,
              '3000': FPDM * 0.23,
              '5000': FPDM * 0.21,
              '10000': FPDM * 0.18,
            },
          },
          {
            height: 4,
            width: 4,
            pricing: {
              '50': FPDM * 1.58,
              '100': FPDM * 1.06,
              '200': FPDM * 0.77,
              '300': FPDM * 0.66,
              '500': FPDM * 0.55,
              '1000': FPDM * 0.45,
              '2000': FPDM * 0.38,
              '3000': FPDM * 0.34,
              '5000': FPDM * 0.31,
              '10000': FPDM * 0.3,
            },
          },
          {
            height: 5,
            width: 5,
            pricing: {
              '50': FPDM * 1.86,
              '100': FPDM * 1.3,
              '200': FPDM * 0.98,
              '300': FPDM * 0.85,
              '500': FPDM * 0.73,
              '1000': FPDM * 0.61,
              '2000': FPDM * 0.52,
              '3000': FPDM * 0.48,
              '5000': FPDM * 0.46,
              '10000': FPDM * 0.45,
            },
          },
        ],
      },
      Circle: {
        label: 'Circle stickers',
        description:
          'Custom circle stickers are a fast and easy way to promote your business, brand or event. Thick, durable vinyl protects your stickers from scratches, water and sunlight.',
        isCircular: true,
        sizes: [
          {
            height: 1,
            width: 1,
            pricing: {
              '50': FPDM * 1.02,
              '100': FPDM * 0.57,
              '200': FPDM * 0.34,
              '300': FPDM * 0.25,
              '500': FPDM * 0.18,
              '1000': FPDM * 0.13,
              '2000': FPDM * 0.09,
              '3000': FPDM * 0.08,
              '5000': FPDM * 0.07,
              '10000': FPDM * 0.05,
            },
          },
          {
            height: 2,
            width: 2,
            pricing: {
              '50': FPDM * 1.16,
              '100': FPDM * 0.69,
              '200': FPDM * 0.44,
              '300': FPDM * 0.35,
              '500': FPDM * 0.27,
              '1000': FPDM * 0.2,
              '2000': FPDM * 0.16,
              '3000': FPDM * 0.14,
              '5000': FPDM * 0.13,
              '10000': FPDM * 0.11,
            },
          },
          {
            height: 3,
            width: 3,
            pricing: {
              '50': FPDM * 1.36,
              '100': FPDM * 0.86,
              '200': FPDM * 0.59,
              '300': FPDM * 0.49,
              '500': FPDM * 0.4,
              '1000': FPDM * 0.31,
              '2000': FPDM * 0.26,
              '3000': FPDM * 0.23,
              '5000': FPDM * 0.21,
              '10000': FPDM * 0.18,
            },
          },
          {
            height: 4,
            width: 4,
            pricing: {
              '50': FPDM * 1.58,
              '100': FPDM * 1.06,
              '200': FPDM * 0.77,
              '300': FPDM * 0.66,
              '500': FPDM * 0.55,
              '1000': FPDM * 0.45,
              '2000': FPDM * 0.38,
              '3000': FPDM * 0.34,
              '5000': FPDM * 0.31,
              '10000': FPDM * 0.3,
            },
          },
        ],
      },
      Rectangle: {
        label: 'Rectangle stickers',
        description:
          'Custom rectangle stickers are a fast and easy way to promote your business, brand or event. Thick, durable vinyl protects your stickers from scratches, water & sunlight.',
        sizes: [
          {
            height: 2,
            width: 1,
            pricing: {
              '50': FPDM * 1.08,
              '100': FPDM * 0.61,
              '200': FPDM * 0.37,
              '300': FPDM * 0.29,
              '500': FPDM * 0.22,
              '1000': FPDM * 0.15,
              '2000': FPDM * 0.12,
              '3000': FPDM * 0.1,
              '5000': FPDM * 0.09,
              '10000': FPDM * 0.07,
            },
          },
          {
            height: 3,
            width: 2,
            pricing: {
              '50': FPDM * 1.24,
              '100': FPDM * 0.76,
              '200': FPDM * 0.5,
              '300': FPDM * 0.41,
              '500': FPDM * 0.32,
              '1000': FPDM * 0.25,
              '2000': FPDM * 0.2,
              '3000': FPDM * 0.18,
              '5000': FPDM * 0.16,
              '10000': FPDM * 0.14,
            },
          },
          {
            height: 4,
            width: 2,
            pricing: {
              '50': FPDM * 1.32,
              '100': FPDM * 0.82,
              '200': FPDM * 0.56,
              '300': FPDM * 0.46,
              '500': FPDM * 0.37,
              '1000': FPDM * 0.29,
              '2000': FPDM * 0.24,
              '3000': FPDM * 0.22,
              '5000': FPDM * 0.19,
              '10000': FPDM * 0.17,
            },
          },
          {
            height: 5,
            width: 3,
            pricing: {
              '50': FPDM * 1.56,
              '100': FPDM * 1.03,
              '200': FPDM * 0.74,
              '300': FPDM * 0.63,
              '500': FPDM * 0.53,
              '1000': FPDM * 0.43,
              '2000': FPDM * 0.36,
              '3000': FPDM * 0.33,
              '5000': FPDM * 0.3,
              '10000': FPDM * 0.28,
            },
          },
        ],
      },
      Square: {
        label: 'Square stickers',
        description:
          'Custom square stickers are a fast and easy way to promote your business, brand or event. Thick, durable vinyl protects your stickers from scratches, water & sunlight.',
        sizes: [
          {
            height: 2,
            width: 2,
            pricing: {
              '50': FPDM * 1.16,
              '100': FPDM * 0.69,
              '200': FPDM * 0.44,
              '300': FPDM * 0.35,
              '500': FPDM * 0.27,
              '1000': FPDM * 0.2,
              '2000': FPDM * 0.16,
              '3000': FPDM * 0.14,
              '5000': FPDM * 0.13,
              '10000': FPDM * 0.11,
            },
          },
          {
            height: 3,
            width: 3,
            pricing: {
              '50': FPDM * 1.36,
              '100': FPDM * 0.86,
              '200': FPDM * 0.59,
              '300': FPDM * 0.49,
              '500': FPDM * 0.4,
              '1000': FPDM * 0.31,
              '2000': FPDM * 0.26,
              '3000': FPDM * 0.23,
              '5000': FPDM * 0.21,
              '10000': FPDM * 0.18,
            },
          },
          {
            height: 4,
            width: 4,
            pricing: {
              '50': FPDM * 1.58,
              '100': FPDM * 1.06,
              '200': FPDM * 0.77,
              '300': FPDM * 0.66,
              '500': FPDM * 0.55,
              '1000': FPDM * 0.45,
              '2000': FPDM * 0.38,
              '3000': FPDM * 0.34,
              '5000': FPDM * 0.31,
              '10000': FPDM * 0.3,
            },
          },
          {
            height: 5,
            width: 5,
            pricing: {
              '50': FPDM * 1.86,
              '100': FPDM * 1.3,
              '200': FPDM * 0.98,
              '300': FPDM * 0.85,
              '500': FPDM * 0.73,
              '1000': FPDM * 0.61,
              '2000': FPDM * 0.52,
              '3000': FPDM * 0.48,
              '5000': FPDM * 0.46,
              '10000': FPDM * 0.45,
            },
          },
        ],
      },
      Oval: {
        label: 'Oval stickers',
        description:
          'Custom oval stickers are a fast and easy way to promote your business, brand or event. Thick, durable vinyl protects your stickers from scratches, water & sunlight.',
        isCircular: true,
        sizes: [
          {
            height: 3,
            width: 2,
            pricing: {
              '50': FPDM * 1.24,
              '100': FPDM * 0.76,
              '200': FPDM * 0.5,
              '300': FPDM * 0.41,
              '500': FPDM * 0.32,
              '1000': FPDM * 0.25,
              '2000': FPDM * 0.2,
              '3000': FPDM * 0.18,
              '5000': FPDM * 0.16,
              '10000': FPDM * 0.14,
            },
          },
          {
            height: 4,
            width: 2,
            pricing: {
              '50': FPDM * 1.32,
              '100': FPDM * 0.82,
              '200': FPDM * 0.56,
              '300': FPDM * 0.46,
              '500': FPDM * 0.37,
              '1000': FPDM * 0.29,
              '2000': FPDM * 0.24,
              '3000': FPDM * 0.22,
              '5000': FPDM * 0.19,
              '10000': FPDM * 0.17,
            },
          },
          {
            height: 5,
            width: 3,
            pricing: {
              '50': FPDM * 1.56,
              '100': FPDM * 1.03,
              '200': FPDM * 0.74,
              '300': FPDM * 0.63,
              '500': FPDM * 0.53,
              '1000': FPDM * 0.43,
              '2000': FPDM * 0.36,
              '3000': FPDM * 0.33,
              '5000': FPDM * 0.3,
              '10000': FPDM * 0.28,
            },
          },
          {
            height: 6,
            width: 4,
            pricing: {
              '50': FPDM * 1.82,
              '100': FPDM * 1.28,
              '200': FPDM * 0.96,
              '300': FPDM * 0.83,
              '500': FPDM * 0.71,
              '1000': FPDM * 0.59,
              '2000': FPDM * 0.5,
              '3000': FPDM * 0.46,
              '5000': FPDM * 0.45,
              '10000': FPDM * 0.44,
            },
          },
        ],
      },
      Bumper: {
        label: 'Bumper stickers',
        description:
          'Make your own bumper stickers with removable adhesive, ideal for cars and trucks. Thick, durable vinyl protects your bumper sticker from scratches, water & sunlight. Display your own message or design in any shape & color.',
        sizes: [
          {
            height: 7.5,
            width: 3.75,
            pricing: {
              '10': FPDM * 2.8,
              '50': FPDM * 2,
              '100': FPDM * 1.44,
              '200': FPDM * 1.11,
              '300': FPDM * 0.97,
              '500': FPDM * 0.84,
              '1000': FPDM * 0.71,
              '2000': FPDM * 0.61,
              '3000': FPDM * 0.56,
              '5000': FPDM * 0.54,
            },
          },
          {
            height: 11.5,
            width: 3,
            pricing: {
              '10': FPDM * 3.1,
              '50': FPDM * 2.2,
              '100': FPDM * 1.61,
              '200': FPDM * 1.26,
              '300': FPDM * 1.11,
              '500': FPDM * 0.97,
              '1000': FPDM * 0.82,
              '2000': FPDM * 0.71,
              '3000': FPDM * 0.67,
              '5000': FPDM * 0.66,
            },
          },
          {
            height: 15,
            width: 3.75,
            pricing: {
              '10': FPDM * 3.9,
              '50': FPDM * 2.82,
              '100': FPDM * 2.16,
              '200': FPDM * 1.74,
              '300': FPDM * 1.56,
              '500': FPDM * 1.38,
              '1000': FPDM * 1.18,
              '2000': FPDM * 1.07,
              '3000': FPDM * 1.06,
              '5000': FPDM * 1.05,
            },
          },
        ],
      },
      'Sticker sheets': {
        label: 'Sticker sheets',
        description:
          'Custom sticker sheets let you fit multiple sticker designs on one sheet. Customize the entire page and place stickers anywhere you like.',
        sizes: [
          {
            height: 4,
            width: 6,
            pricing: {
              '10': FPDM * 3.3,
              '50': FPDM * 2.38,
              '100': FPDM * 1.77,
              '200': FPDM * 1.39,
              '300': FPDM * 1.24,
              '500': FPDM * 1.08,
              '1000': FPDM * 0.92,
              '2000': FPDM * 0.79,
              '3000': FPDM * 0.73,
              '5000': FPDM * 0.66,
            },
          },
          {
            height: 8.5,
            width: 11,
            pricing: {
              '10': FPDM * 7.2,
              '50': FPDM * 5.3,
              '100': FPDM * 4.35,
              '200': FPDM * 3.68,
              '300': FPDM * 3.36,
              '500': FPDM * 3.02,
              '1000': FPDM * 2.63,
              '2000': FPDM * 2.3,
              '3000': FPDM * 2.21,
              '5000': FPDM * 2.2,
            },
          },
        ],
      },
      'Kiss cut': {
        label: 'Kiss cut stickers',
        description:
          'Custom kiss cut stickers easily peel away from the backing. Print on the surrounding border as well as the stickers. Made from durable vinyl that resists scratching, heat, water and sunlight.',
        sizes: [
          {
            height: 2,
            width: 2,
            pricing: {
              '50': FPDM * 1.2,
              '100': FPDM * 0.73,
              '200': FPDM * 0.48,
              '300': FPDM * 0.39,
              '500': FPDM * 0.31,
              '1000': FPDM * 0.24,
              '2000': FPDM * 0.19,
              '3000': FPDM * 0.17,
              '5000': FPDM * 0.15,
              '10000': FPDM * 0.13,
            },
          },
          {
            height: 3,
            width: 3,
            pricing: {
              '50': FPDM * 1.44,
              '100': FPDM * 0.95,
              '200': FPDM * 0.67,
              '300': FPDM * 0.57,
              '500': FPDM * 0.47,
              '1000': FPDM * 0.38,
              '2000': FPDM * 0.32,
              '3000': FPDM * 0.29,
              '5000': FPDM * 0.26,
              '10000': FPDM * 0.22,
            },
          },
          {
            height: 4,
            width: 4,
            pricing: {
              '50': FPDM * 1.74,
              '100': FPDM * 1.21,
              '200': FPDM * 0.9,
              '300': FPDM * 0.78,
              '500': FPDM * 0.67,
              '1000': FPDM * 0.55,
              '2000': FPDM * 0.47,
              '3000': FPDM * 0.43,
              '5000': FPDM * 0.39,
              '10000': FPDM * 0.34,
            },
          },
          {
            height: 5,
            width: 5,
            pricing: {
              '50': FPDM * 2.1,
              '100': FPDM * 1.52,
              '200': FPDM * 1.18,
              '300': FPDM * 1.04,
              '500': FPDM * 0.9,
              '1000': FPDM * 0.76,
              '2000': FPDM * 0.65,
              '3000': FPDM * 0.6,
              '5000': FPDM * 0.54,
              '10000': FPDM * 0.51,
            },
          },
        ],
      },
      'Rounded corner': {
        label: 'Rounded corner stickers',
        description:
          'Custom rounded corner stickers are a fast and easy way to promote your business, brand or event. Thick, durable vinyl protects your stickers from scratches, water & sunlight.',
        sizes: [
          {
            height: 2,
            width: 2,
            pricing: {
              '50': FPDM * 1.16,
              '100': FPDM * 0.69,
              '200': FPDM * 0.44,
              '300': FPDM * 0.35,
              '500': FPDM * 0.27,
              '1000': FPDM * 0.2,
              '2000': FPDM * 0.16,
              '3000': FPDM * 0.14,
              '5000': FPDM * 0.13,
              '10000': FPDM * 0.11,
            },
          },
          {
            height: 3,
            width: 3,
            pricing: {
              '50': FPDM * 1.36,
              '100': FPDM * 0.86,
              '200': FPDM * 0.59,
              '300': FPDM * 0.49,
              '500': FPDM * 0.4,
              '1000': FPDM * 0.31,
              '2000': FPDM * 0.26,
              '3000': FPDM * 0.23,
              '5000': FPDM * 0.21,
              '10000': FPDM * 0.18,
            },
          },
          {
            height: 4,
            width: 4,
            pricing: {
              '50': FPDM * 1.58,
              '100': FPDM * 1.06,
              '200': FPDM * 0.77,
              '300': FPDM * 0.66,
              '500': FPDM * 0.55,
              '1000': FPDM * 0.45,
              '2000': FPDM * 0.38,
              '3000': FPDM * 0.34,
              '5000': FPDM * 0.31,
              '10000': FPDM * 0.3,
            },
          },
          {
            height: 5,
            width: 5,
            pricing: {
              '50': FPDM * 1.86,
              '100': FPDM * 1.3,
              '200': FPDM * 0.98,
              '300': FPDM * 0.85,
              '500': FPDM * 0.73,
              '1000': FPDM * 0.61,
              '2000': FPDM * 0.52,
              '3000': FPDM * 0.48,
              '5000': FPDM * 0.46,
              '10000': FPDM * 0.45,
            },
          },
        ],
      },
      Clear: {
        label: 'Clear stickers',
        description:
          'Custom clear stickers are printed with white ink behind your design to preserve opacity. Perfect for windows, bottles, as product labels or just to give your stickers a unique look.',
        sizes: [
          {
            height: 2,
            width: 2,
            pricing: {
              '50': FPDM * 1.24,
              '100': FPDM * 0.76,
              '200': FPDM * 0.5,
              '300': FPDM * 0.41,
              '500': FPDM * 0.33,
              '1000': FPDM * 0.26,
              '2000': FPDM * 0.21,
              '3000': FPDM * 0.19,
              '5000': FPDM * 0.16,
              '10000': FPDM * 0.14,
            },
          },
          {
            height: 3,
            width: 3,
            pricing: {
              '50': FPDM * 1.5,
              '100': FPDM * 1,
              '200': FPDM * 0.72,
              '300': FPDM * 0.61,
              '500': FPDM * 0.51,
              '1000': FPDM * 0.41,
              '2000': FPDM * 0.35,
              '3000': FPDM * 0.32,
              '5000': FPDM * 0.28,
              '10000': FPDM * 0.24,
            },
          },
          {
            height: 4,
            width: 4,
            pricing: {
              '50': FPDM * 1.84,
              '100': FPDM * 1.29,
              '200': FPDM * 0.98,
              '300': FPDM * 0.85,
              '500': FPDM * 0.73,
              '1000': FPDM * 0.61,
              '2000': FPDM * 0.52,
              '3000': FPDM * 0.48,
              '5000': FPDM * 0.43,
              '10000': FPDM * 0.38,
            },
          },
          {
            height: 5,
            width: 5,
            pricing: {
              '50': FPDM * 2.24,
              '100': FPDM * 1.64,
              '200': FPDM * 1.29,
              '300': FPDM * 1.14,
              '500': FPDM * 0.99,
              '1000': FPDM * 0.84,
              '2000': FPDM * 0.72,
              '3000': FPDM * 0.67,
              '5000': FPDM * 0.6,
              '10000': FPDM * 0.57,
            },
          },
        ],
      },
      Transfer: {
        label: 'Transfer stickers',
        description:
          'Custom transfer stickers make it easy to apply the most intricate designs. Available in white or black vinyl, our transfer stickers are durable & ideal for indoor or outdoor use.',
        sizes: [
          {
            height: 4,
            width: 4,
            pricing: {
              '1': FPDM * 19,
              '10': FPDM * 4.4,
              '50': FPDM * 2.06,
              '100': FPDM * 1.51,
              '200': FPDM * 1.25,
              '300': FPDM * 1.17,
              '500': FPDM * 1.11,
              '1000': FPDM * 1.06,
            },
          },
          {
            height: 5,
            width: 5,
            pricing: {
              '1': FPDM * 20,
              '10': FPDM * 5.1,
              '50': FPDM * 2.56,
              '100': FPDM * 1.98,
              '200': FPDM * 1.77,
              '300': FPDM * 1.7,
              '500': FPDM * 1.63,
              '1000': FPDM * 1.58,
            },
          },
          {
            height: 6,
            width: 6,
            pricing: {
              '1': FPDM * 21,
              '10': FPDM * 5.8,
              '50': FPDM * 3.12,
              '100': FPDM * 2.63,
              '200': FPDM * 2.41,
              '300': FPDM * 2.34,
              '500': FPDM * 2.27,
              '1000': FPDM * 2.22,
            },
          },
        ],
      },
      Cling: {
        label: 'Cling stickers',
        description:
          'Custom static clings are designed to firmly hold to any glass surface without using adhesive. Each static cling can be printed in full color and cut to fit the shape and size of your design.',
        sizes: [
          {
            height: 2,
            width: 2,
            pricing: {
              '50': FPDM * 1.1,
              '100': FPDM * 0.64,
              '200': FPDM * 0.4,
              '300': FPDM * 0.32,
              '500': FPDM * 0.24,
              '1000': FPDM * 0.18,
              '2000': FPDM * 0.14,
              '3000': FPDM * 0.12,
              '5000': FPDM * 0.11,
              '10000': FPDM * 0.09,
            },
          },
          {
            height: 3,
            width: 3,
            pricing: {
              '50': FPDM * 1.24,
              '100': FPDM * 0.77,
              '200': FPDM * 0.52,
              '300': FPDM * 0.42,
              '500': FPDM * 0.34,
              '1000': FPDM * 0.27,
              '2000': FPDM * 0.22,
              '3000': FPDM * 0.19,
              '5000': FPDM * 0.17,
              '10000': FPDM * 0.15,
            },
          },
          {
            height: 4,
            width: 4,
            pricing: {
              '50': FPDM * 1.44,
              '100': FPDM * 0.93,
              '200': FPDM * 0.66,
              '300': FPDM * 0.56,
              '500': FPDM * 0.46,
              '1000': FPDM * 0.37,
              '2000': FPDM * 0.31,
              '3000': FPDM * 0.28,
              '5000': FPDM * 0.25,
              '10000': FPDM * 0.22,
            },
          },
          {
            height: 5,
            width: 5,
            pricing: {
              '50': FPDM * 1.64,
              '100': FPDM * 1.13,
              '200': FPDM * 0.83,
              '300': FPDM * 0.71,
              '500': FPDM * 0.6,
              '1000': FPDM * 0.5,
              '2000': FPDM * 0.42,
              '3000': FPDM * 0.38,
              '5000': FPDM * 0.35,
              '10000': FPDM * 0.3,
            },
          },
        ],
      },
      'Front adhesive': {
        label: 'Front adhesive stickers',
        description:
          'Custom front adhesive stickers, also known as window decals, are sticky on the front of your design for use on the inside of a window. Ideal for shop fronts, businesses and membership or tourism logos.',
        sizes: [
          {
            height: 2,
            width: 2,
            pricing: {
              '50': FPDM * 1.24,
              '100': FPDM * 0.76,
              '200': FPDM * 0.5,
              '300': FPDM * 0.41,
              '500': FPDM * 0.33,
              '1000': FPDM * 0.26,
              '2000': FPDM * 0.21,
              '3000': FPDM * 0.19,
              '5000': FPDM * 0.16,
            },
          },
          {
            height: 3,
            width: 3,
            pricing: {
              '50': FPDM * 1.5,
              '100': FPDM * 1,
              '200': FPDM * 0.72,
              '300': FPDM * 0.61,
              '500': FPDM * 0.51,
              '1000': FPDM * 0.41,
              '2000': FPDM * 0.35,
              '3000': FPDM * 0.32,
              '5000': FPDM * 0.28,
            },
          },
          {
            height: 4,
            width: 4,
            pricing: {
              '50': FPDM * 1.84,
              '100': FPDM * 1.29,
              '200': FPDM * 0.98,
              '300': FPDM * 0.85,
              '500': FPDM * 0.73,
              '1000': FPDM * 0.61,
              '2000': FPDM * 0.52,
              '3000': FPDM * 0.48,
              '5000': FPDM * 0.43,
            },
          },
          {
            height: 5,
            width: 5,
            pricing: {
              '50': FPDM * 2.24,
              '100': FPDM * 1.64,
              '200': FPDM * 1.29,
              '300': FPDM * 1.14,
              '500': FPDM * 0.99,
              '1000': FPDM * 0.84,
              '2000': FPDM * 0.72,
              '3000': FPDM * 0.67,
              '5000': FPDM * 0.6,
            },
          },
        ],
      },
      Holographic: {
        label: 'Holographic stickers',
        description:
          'Custom holographic stickers are a fast and easy way to promote your business, brand or event. Holographic vinyl has an eye-catching rainbow effect which changes with light and perspective.',
        sizes: [
          {
            height: 2,
            width: 2,
            pricing: {
              '50': FPDM * 1.3,
              '100': FPDM * 0.81,
              '200': FPDM * 0.54,
              '300': FPDM * 0.44,
              '500': FPDM * 0.35,
              '1000': FPDM * 0.28,
              '2000': FPDM * 0.22,
              '3000': FPDM * 0.2,
              '5000': FPDM * 0.18,
              '10000': FPDM * 0.17,
            },
          },
          {
            height: 3,
            width: 3,
            pricing: {
              '50': FPDM * 1.6,
              '100': FPDM * 1.07,
              '200': FPDM * 0.77,
              '300': FPDM * 0.66,
              '500': FPDM * 0.55,
              '1000': FPDM * 0.45,
              '2000': FPDM * 0.39,
              '3000': FPDM * 0.37,
              '5000': FPDM * 0.36,
              '10000': FPDM * 0.36,
            },
          },
          {
            height: 4,
            width: 4,
            pricing: {
              '50': FPDM * 1.6,
              '100': FPDM * 1.07,
              '200': FPDM * 0.77,
              '300': FPDM * 0.66,
              '500': FPDM * 0.55,
              '1000': FPDM * 0.45,
              '2000': FPDM * 0.39,
              '3000': FPDM * 0.37,
              '5000': FPDM * 0.36,
              '10000': FPDM * 0.36,
            },
          },
          {
            height: 5,
            width: 5,
            pricing: {
              '50': FPDM * 2.42,
              '100': FPDM * 1.79,
              '200': FPDM * 1.41,
              '300': FPDM * 1.25,
              '500': FPDM * 1.09,
              '1000': FPDM * 0.99,
              '2000': FPDM * 0.97,
              '3000': FPDM * 0.95,
              '5000': FPDM * 0.94,
              '10000': FPDM * 0.93,
            },
          },
        ],
      },
    },
    cardColor: '#CFE1E7',
    textColor: '#2B5C6C',
    invoiceTitle: 'Custom Sticker',
    description: 'Select a type, size, quantity and upload an image to create custom stickers for your needs.',
    exampleImages: [
      `${STATIC_FILE_URL}/dcdd085d1f5eccd0f9057a859211d7a3.png`,
      `${STATIC_FILE_URL}/e020996b6a40cce8feebdc147f6d6372.png`,
      `${STATIC_FILE_URL}/088619863ad1f9b28e28a81c9292a2ea.png`,
      `${STATIC_FILE_URL}/201a14ad884f50ae59d24803c693624c.png`,
    ],
    startingPointTitle: 'Stickers',
  },
  [FeaturedPackagingCategory.TISSUE_PAPER]: {
    kind: PackagingKind.FEATURED,
    key: FeaturedPackagingCategory.TISSUE_PAPER,
    categoryId: 3206,
    image: `${STATIC_FILE_URL}/84ea2cedf81e450501b50aa56110d888.png`,
    title: 'Tissue Paper',
    options: {
      default: {
        label: 'default',
        sizes: [
          {
            height: 9,
            width: 12,
            pricing: {
              '250': FPDM * 0.7,
              '500': FPDM * 0.38,
              '1000': FPDM * 0.21,
              '2000': FPDM * 0.13,
              '2500': FPDM * 0.11,
              '5000': FPDM * 0.08,
            },
          },
          {
            height: 15,
            width: 15,
            pricing: {
              '250': FPDM * 0.74,
              '500': FPDM * 0.42,
              '1000': FPDM * 0.26,
              '2000': FPDM * 0.19,
              '2500': FPDM * 0.16,
              '5000': FPDM * 0.11,
            },
          },
          {
            height: 15,
            width: 20,
            pricing: {
              '250': FPDM * 0.82,
              '500': FPDM * 0.47,
              '1000': FPDM * 0.29,
              '2000': FPDM * 0.2,
              '2500': FPDM * 0.18,
              '5000': FPDM * 0.15,
            },
          },
          {
            height: 20,
            width: 20,
            pricing: {
              '250': FPDM * 0.86,
              '500': FPDM * 0.5,
              '1000': FPDM * 0.31,
              '2000': FPDM * 0.21,
              '2500': FPDM * 0.19,
              '5000': FPDM * 0.17,
            },
          },
          {
            height: 20,
            width: 30,
            pricing: {
              '250': FPDM * 0.9,
              '500': FPDM * 0.54,
              '1000': FPDM * 0.37,
              '2000': FPDM * 0.28,
              '2500': FPDM * 0.27,
              '5000': FPDM * 0.25,
            },
          },
          {
            height: 24,
            width: 24,
            pricing: {
              '250': FPDM * 0.92,
              '500': FPDM * 0.58,
              '1000': FPDM * 0.42,
              '2000': FPDM * 0.3,
              '2500': FPDM * 0.28,
              '5000': FPDM * 0.25,
            },
          },
          {
            height: 24,
            width: 35,
            pricing: {
              '250': FPDM * 0.62,
              '500': FPDM * 0.38,
              '1000': FPDM * 0.3,
              '2000': FPDM * 0.22,
              '2500': FPDM * 0.21,
              '5000': FPDM * 0.2,
            },
          },
        ],
      },
    },
    cardColor: '#DAD7D2',
    textColor: '#6A4E36',
    invoiceTitle: 'Custom Tissue Paper',
    description: 'Select a size, quantity and upload an image to create custom tissue paper for your needs.',
    exampleImages: [
      `${STATIC_FILE_URL}/e0ef08ab8ce4c062b719938ca272db17.png`,
      `${STATIC_FILE_URL}/8ca2f0524e691c43d99ab628751fe861.png`,
    ],
    placementSubtitle:
      'Please upload an image with up to 2 colors only. You will be able to proof the final tissue paper with a Pietra rep.',
    startingPointTitle: 'Tissue Paper',
  },
};

const { TYPE, SIZE, QUANTITY, DESCRIPTION, PLACEMENTS, COLORS, PAPER_TYPE } = FeaturedPackagingAttributeKey;

export const SOURCING_HOME_FAST_SHIPPING_PACKAGING: PackagingCard[] = [
  CUSTOM_PACKAGING_CONFIG[FeaturedPackagingCategory.POLYMAILERS],
  CUSTOM_PACKAGING_CONFIG[FeaturedPackagingCategory.NOTECARDS],
  CUSTOM_PACKAGING_CONFIG[FeaturedPackagingCategory.STICKERS],
  CUSTOM_PACKAGING_CONFIG[FeaturedPackagingCategory.TISSUE_PAPER],
];

export const SOURCING_HOME_LOW_COST_PACKAGING: PackagingCard[] = [
  {
    kind: PackagingKind.CUSTOM,
    image: `${STATIC_FILE_URL}/fb07f6eacc98ce4b2bcc271410d8d680.png`,
    title: 'Eco-friendly 100% Recycled Poly ',
    startingPointTitle: 'Eco-friendly 100% Recycled Poly ',
    options: {
      default: {
        label: 'default',
        sizes: [
          {
            pricing: {
              '500': 0.18,
              '1000': 0.13,
              '3000': 0.12,
              '5000': 0.09,
            },
          },
        ],
      },
    },
    cardColor: '#E7D4CF',
    textColor: '#804434',
    exampleImages: [
      `${STATIC_FILE_URL}/fb07f6eacc98ce4b2bcc271410d8d680.png`,
      `${STATIC_FILE_URL}/ed8d18fcbc28bb7db9cbc4a9c790020c.jpg`,
      `${STATIC_FILE_URL}/d0ec7cdfa8f336576136e5a989b24bd4.jpg`,
      `${STATIC_FILE_URL}/47dd8ddf059288c42308d2a3ea97a79e.jpg`,
    ],
    supplierName: 'YOKO Packaging',
    catalogItemId: null,
  },
  {
    kind: PackagingKind.CUSTOM,
    image: `${STATIC_FILE_URL}/9d3fbe0c1d3bd98fafe54f7bdbe68ecb.png`,
    title: 'Corrugated Mailer Boxes',
    startingPointTitle: 'Corrugated Mailer Boxes',
    options: {
      default: {
        label: 'default',
        sizes: [
          {
            pricing: {
              '500': 0.2,
              '1000': 0.1,
              '10000': 0.05,
              '200000': 0.01,
            },
          },
        ],
      },
    },
    cardColor: '#DAD7D2',
    textColor: '#6A4E36',
    exampleImages: [
      `${STATIC_FILE_URL}/9d3fbe0c1d3bd98fafe54f7bdbe68ecb.png`,
      `${STATIC_FILE_URL}/ed8d18fcbc28bb7db9cbc4a9c790020c.jpg`,
      `${STATIC_FILE_URL}/d0ec7cdfa8f336576136e5a989b24bd4.jpg`,
      `${STATIC_FILE_URL}/47dd8ddf059288c42308d2a3ea97a79e.jpg`,
    ],
    supplierName: 'YOKO Packaging',
    catalogItemId: null,
  },
  {
    kind: PackagingKind.CUSTOM,
    image: `${STATIC_FILE_URL}/cd71d80d6d36a1e03985e77e78417dcd.jpeg`,
    title: 'Cardstock Boxes',
    startingPointTitle: 'Cardstock Boxes',
    options: {
      default: {
        label: 'default',
        sizes: [
          {
            pricing: {
              '500': 0.2,
              '1000': 0.1,
              '10000': 0.05,
              '200000': 0.01,
            },
          },
        ],
      },
    },
    cardColor: '#E7CEDF',
    textColor: '#442239',
    exampleImages: [
      `${STATIC_FILE_URL}/cd71d80d6d36a1e03985e77e78417dcd.jpeg`,
      `${STATIC_FILE_URL}/ed8d18fcbc28bb7db9cbc4a9c790020c.jpg`,
      `${STATIC_FILE_URL}/d0ec7cdfa8f336576136e5a989b24bd4.jpg`,
      `${STATIC_FILE_URL}/47dd8ddf059288c42308d2a3ea97a79e.jpg`,
    ],
    supplierName: 'YOKO Packaging',
    catalogItemId: null,
  },
];

export const ATTRIBUTE_OPTIONS: { [key: string]: FeaturedPackagingAttribute } = {
  [TYPE]: {
    key: TYPE,
    title: 'Select a type',
    linkText: 'Custom type? Talk to us.',
  },
  [SIZE]: {
    key: SIZE,
    title: 'Select a size',
    linkText: 'Custom size? Talk to us.',
  },
  [QUANTITY]: {
    key: QUANTITY,
    title: 'Select a quantity',
    linkText: 'Custom quantity? Talk to us.',
  },
  [DESCRIPTION]: {
    key: DESCRIPTION,
    title: 'Describe your project',
    subtitle: 'Provide notes to the Pietra rep to review for proofing.',
  },
  [PLACEMENTS]: {
    key: PLACEMENTS,
    title: 'Print sides',
  },
  [COLORS]: {
    key: COLORS,
    title: 'Colors',
  },
  [PAPER_TYPE]: {
    key: PAPER_TYPE,
    title: 'Paper type',
  },
};

export const PLACEMENT_OPTIONS = {
  [FeaturedPackagingCategory.POLYMAILERS]: {
    [PlacementOption.FRONT_ONLY]: {
      title: PlacementOption.FRONT_ONLY,
      imageUrl: '/images/sourcing/polymailers-front.png',
    },
    [PlacementOption.FRONT_BACK]: {
      title: PlacementOption.FRONT_BACK,
      imageUrl: '/images/sourcing/polymailer-icon.png',
    },
  },
  [FeaturedPackagingCategory.NOTECARDS]: {
    [PlacementOption.FRONT_ONLY]: {
      title: PlacementOption.FRONT_ONLY,
      imageUrl: '/images/sourcing/notecards-front.png',
    },
    [PlacementOption.FRONT_BACK]: {
      title: PlacementOption.FRONT_BACK,
      imageUrl: '/images/sourcing/notecards-front-back.png',
    },
  },
};

export const FEATURED_PACKAGING_OPTIONS = {
  [FeaturedPackagingCategory.POLYMAILERS]: [SIZE, QUANTITY, PLACEMENTS, DESCRIPTION],
  [FeaturedPackagingCategory.STICKERS]: [TYPE, SIZE, QUANTITY, DESCRIPTION],
  [FeaturedPackagingCategory.TISSUE_PAPER]: [SIZE, QUANTITY, COLORS, DESCRIPTION],
  [FeaturedPackagingCategory.NOTECARDS]: [SIZE, QUANTITY, PAPER_TYPE, PLACEMENTS, DESCRIPTION],
};
